// Cognitive/Psychosocial Development subsection form field enum
export enum CognitivePsychosocialFormField {
  COGNITIVE_PSYCHOSOCIAL_COMMUNICATION_ASSESSMENT = 'medicalBackground/cognitivePsychosocial/communicationAssessment',
  COGNITIVE_PSYCHOSOCIAL_COGNITIVE_ASSESSMENT = 'medicalBackground/cognitivePsychosocial/cognitiveAssessment',
  COGNITIVE_PSYCHOSOCIAL_HISTORY_SUBSTANCE_ABUSE = 'medicalBackground/cognitivePsychosocial/historySubstanceAbuse',
  COGNITIVE_PSYCHOSOCIAL_SUBSTANCE_ABUSE_NOTES = 'medicalBackground/cognitivePsychosocial/substanceAbuseNotes',
  COGNITIVE_PSYCHOSOCIAL_SYSTEM_SUMMARY = 'medicalBackground/cognitivePsychosocial/systemSummary'
}
